import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackShortenedUrlAccess = (url: URL) => {
  trackEvent(keys.shortenedUrlAccessed, { redirecturl: url.toString() })
}
